import { createSlice } from "@reduxjs/toolkit";

const url = window.location.href;
const lastRoute = url.split('/').filter(Boolean).pop();
const pagueActual = lastRoute === "dashboard" ? 1 : lastRoute === "table" ? 2 : lastRoute === "analytics" ? 4 : 1;

export const menuViewSlice = createSlice({
	name: "auth",
	initialState: {
        actualPage: pagueActual,
	},
	reducers: {
		onChnageViewTo: (state, { payload }) => {
			state.actualPage = payload;
		},
	},
});

export const { onChnageViewTo } = menuViewSlice.actions;
